import moment from 'moment';
import { IListColumn } from '~/models/listCol';
import { cpfMask, currencyMask } from '~/utils/masks';

export const HeaderReactivatedCustomers = [
  {
    id: 1,
    value: 'Nome completo',
    maxChar: 25,
  },
  {
    id: 2,
    value: 'CPF',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 3,
    value: 'Data Reativação',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 4,
    value: 'Valor Limite',
    maxChar: 15,
    textAlign: 'center',
  },
  {
    id: 5,
    value: 'Cartão Devolvido?',
    maxChar: 15,
    textAlign: 'center',
  },
];

export const BodyReactivatedCustomers = (data: any) => {
  // let x = 0;

  const items = [];

  data.pagina?.forEach((i) => {
    const item: IListColumn[] = [
      // {
      //   type: 'id',
      //   value: x++,
      //   maxChar: 5,
      // },
      {
        value: i.nome,
        maxChar: 25,
      },
      {
        value: i.cpf ? cpfMask(i.cpf).masked : '-',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.dataReativacao
          ? moment(i.dataReativacao).format('DD/MM/YY')
          : '-',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.valorLimite ? `R$ ${currencyMask(i.valorLimite)}` : '-',
        maxChar: 15,
        textAlign: 'center',
      },
      {
        value: i.cartaoDevolvido === true ? 'Sim' : 'Não',
        maxChar: 15,
        textAlign: 'center',
      },
    ];
    items.push(item);
  });
  return items;
};
